import script from "./CountryIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./CountryIcon.vue?vue&type=script&setup=true&lang=ts"

import "./CountryIcon.vue?vue&type=style&index=0&id=1dbb2ed2&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dbb2ed2"]])

export default __exports__